// extracted by mini-css-extract-plugin
export default {"sizes":"\"../../cssvariables/media.module.css\"","tablet-to":"screen and (min-width : 768px)","desktop-to":"screen and (min-width : 1280px)","grid":"styles_grid__HgdVK"};